import React from "react";
import "../scss/input.scss";

const InputItem = ({
  type,
  description,
  placeHolder,
  customStyle,
  item,
  value,
  handleChange,
  id,
  required,
  validation,
}) => {
  return (
    <div
      className={
        customStyle ? `${customStyle}  input-container` : "input-container"
      }
    >
      <h4
        className={`input-title ${
          required ? (validation ? "" : "input-error") : ""
        }`}
      >
        {description} {required ? "*" : ""}
      </h4>
      <div className="flex">
        {item === "text-area" ? (
          <textarea
            id={id}
            className="input-form"
            placeholder={placeHolder}
            rows={5}
            value={value}
            onChange={(e) => handleChange(e)}
          />
        ) : (
          <input
            id={id}
            type={type ? type : 'text'}
            className="input-form"
            placeholder={placeHolder}
            value={value}
            onChange={(e) => handleChange(e)}
          />
        )}
      </div>
    </div>
  );
};

export default InputItem;
